<template>
    <div>
        <div class="head-bar">
            <el-select v-model="datas.add.admin_to" placeholder="请选择" clearable filterable v-if="_is_show_group(10)">
                <el-option v-for="(item, index) in admins" :key="index" :label="item.admin_name" :value="item.id">
                </el-option>
            </el-select>
            <el-button type="default" @click="_load()">刷新</el-button>
        </div>
        <el-table v-loading="datas.status == -1" :data="datas.data" @sort-change="_sort" @selection-change="_select">
            <el-table-column width="200" align="center" fixed prop="id" label="ID" sortable="custom">
                <template slot-scope="scope">
                    <div class="handle-box">
                        <el-button type="text" @click="_info(scope.row.id)">详情</el-button>
                        <el-button type="text" class="c-danger" @click="_del(scope.row.id)">删除</el-button>
                        <div v-if="scope.row.to_admin">
                            提成用户：
                            {{ scope.row.to_admin.admin_name }}
                            {{ scope.row.to_admin.name }}
                            {{ scope.row.to_admin.call }}
                        </div>
                        <ls-status :info="scope.row.status_info"></ls-status>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="项目">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.titles }}
                    </div>
                </template>
            </el-table-column>
            <template v-for="(item, index) in mix_fields">
                <el-table-column :label="item.COLUMN_COMMENT" :width="item.width ? item.width : 'auto'" :key="index">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row[item.COLUMN_NAME] }}
                        </div>
                    </template>
                </el-table-column>
            </template>
            <el-table-column prop="create_time" label="时间" :formatter="_table_time" width="150"></el-table-column>
        </el-table>
        <div class="page-box">
            <el-pagination @size-change="_size" @current-change="_page" :current-page="datas.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="datas.limit" layout="total, sizes, prev, pager, next"
                :total="datas.total">
            </el-pagination>
        </div>
        <ls-mask title="提成详情" @close="show_info = false" v-if="show_info" width="800px">
            <el-button type="warning" @click="show_adj = true"
                v-if="_is_show_group(10) && info.r.status != 4">调整</el-button>
            <table class="table">
                <col>
                <col width="100">
                <tr>
                    <td colspan="3">
                        {{ info.titles }}
                    </td>
                </tr>
                <tr>
                    <td>提成统计</td>
                    <td colspan="2">
                        {{ info.r.num }}
                    </td>
                </tr>
                <tr v-for="(item, index) in info.arr" :key="index">
                    <td>
                        {{ item.title }}
                    </td>
                    <td>
                        {{ item.num }}
                    </td>
                    <td width="100" v-if="_is_show_group(10) && info.r.status != 4">
                        <a @click="_del_tc_log(item.id)">删除</a>
                    </td>
                </tr>
                <tr>
                    <td>实际</td>
                    <td colspan="2">
                        {{ info.r.num_true }}
                    </td>
                </tr>
                <tr>
                    <td colspan="3" class="r">
                        <el-button type="primary" @click="_ok" v-if="info.r.status_info">{{ info.r.status_info.t
                            }}</el-button>
                    </td>
                </tr>
            </table>
        </ls-mask>
        <ls-mask title="调整" @close="show_adj = false" v-if="show_adj" width="500px">
            <el-form>
                <el-form-item label="数量">
                    <el-input v-model="adj.num"></el-input>
                    <div class="f-129">负数表示扣除</div>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="adj.title"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="_adj">提交</el-button>
                </el-form-item>
            </el-form>
        </ls-mask>
        <ls-table-data :table="table" @fields="e => { mix_fields = e }"></ls-table-data>
    </div>
</template>
<script>
export default {
    data() {
        return {
            admins: [],
            adj: {},
            show_adj: false,
            show_info: false,
            table: 'tc',
            datas: {
                add: {
                    append: ['status_info', 'titles', 'to_admin']
                }
            },
            info: {}
        };
    },
    created() {
        this._load();
        this._admins();
    },
    methods: {
        _del_tc_log(id) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.show_info = false;
                this.$http.post('tc_log/del', {
                    id
                }).then(res => {
                    if (res.code) {
                    }
                })
            });
        },
        _admins() {
            this.$http.post('tc/admins', {
            }).then(res => {
                if (res.code) {
                    this.admins = res.data;
                }
            })
        },
        _ok() {
            if (this.info.r.status >= 4) {
                return;
            }
            this.$confirm(`确定操作吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('tc/ok', {
                    id: this.info.r.id
                }).then(res => {
                    if (res.code) {
                        this.show_info = false;
                        this._load();
                    }
                })
            }).catch(() => {
            });
        },
        _adj() {
            this.$http.post('tc/adj', {
                id: this.info.r.id,
                ...this.adj
            }).then(res => {
                if (res.code) {
                    this.show_adj = false;
                    this._info(this.info.r.id);
                }
            })
        },
        _info(id) {
            this.$http.post('tc/info', {
                id,
            }).then(res => {
                if (res.code) {
                    this.info = res.data;
                    this.show_info = true;
                }
            })
        },
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>